import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function getBuildings() {
  const res = await axios.get(`${API}/buildings`);
  return res.data;
}

export async function adminLogin(password) {
  const res = await axios.post(`${API}/admin/login`, { password });
  return res.data; // { token }
}

function authHeaders(token) {
  return { headers: { Authorization: `Bearer ${token}` } };
}

export async function adminGetBuildings(token) {
  const res = await axios.get(`${API}/admin/buildings`, authHeaders(token));
  return res.data;
}

export async function adminCreateBuilding(token, payload) {
  const res = await axios.post(`${API}/admin/buildings`, payload, authHeaders(token));
  return res.data;
}

export async function adminUpdateBuilding(token, id, payload) {
  const res = await axios.put(`${API}/admin/buildings/${id}`, payload, authHeaders(token));
  return res.data;
}

export async function adminDeleteBuilding(token, id) {
  const res = await axios.delete(`${API}/admin/buildings/${id}`, authHeaders(token));
  return res.data;
}

export async function adminReseed(token) {
  const res = await axios.post(`${API}/admin/reseed`, {}, authHeaders(token));
  return res.data;
}
